
import { Component, Vue, Prop } from "vue-property-decorator";
import ModalCovered from "../_components/ModalCovered";
import serial_number_input_labels from "@/assets/serial_numbers.js";

@Component
export default class SerialNumber extends ModalCovered {
  button_compare_class = "active";
  compare_tab_class = "comparetab";
  button_repairs_class = "inactive";
  repairs_tab_class = "repairtab hide";
  drop_down_class = "mobile-compare-dropdown";
  compare3_show = true;
  compare4_show = true;
  selected_company = "Square Trade";

  labels;

  deviceType: string;
  // make: string;
  // model: string;

  constructor() {
    super();
    this.deviceType = "";
    this.labels = serial_number_input_labels;
    // this.make = '';
    // this.model = '';
  }

  get selectedModel() {
    return this.deviceType;
  }

  get banners() {
    if (this.labels != undefined && this.labels.length !== 0) {
      let obj = this.labels.find((l) => l.name == this.selectedModel);

      if (obj != undefined && obj) {
        return obj.banners.join("");
      } else {
        return "";
      }
    }
    return "";
  }

  // get makeLabels() {
  //   if(this.deviceType && serial_number_input_labels != undefined && serial_number_input_labels){
  //     const makeLabels = serial_number_input_labels.find(l => l.name == this.deviceType);
  //     if(makeLabels != undefined && makeLabels && makeLabels.make != undefined){
  //       this.model = '';
  //       this.make = '';
  //       if(makeLabels.make.length == 1){
  //         this.make = makeLabels.make[0].name;
  //       }
  //       return makeLabels.make;
  //     }
  //     else{
  //       this.model = '';
  //       this.make = '';
  //       return [];
  //     }
  //   }
  //   this.model = '';
  //   this.make = '';
  //   return [];
  // }

  // get modelLabels() {
  //   if(this.makeLabels!= undefined && this.makeLabels.length !== 0){
  //     const modelLabels = this.makeLabels.find(l => l.name == this.make);
  //     if(modelLabels != undefined && modelLabels && modelLabels.model != undefined){
  //       this.model = '';
  //       if(modelLabels.model.length == 1){
  //         this.model = modelLabels.model[0].name;
  //       }
  //       return 'modelLabels.model';
  //     }
  //     else{
  //       this.model = '';
  //       return [];
  //     }
  //   }
  //   this.model = '';
  //   return [];
  // }
}
